var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBidAcceptedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.31615 0.854248C1.31116 0.854248 0.483337 1.68207 0.483337 2.68706V15.3131C0.483337 16.3181 1.31116 17.1459 2.31615 17.1459H11.6839C12.6888 17.1459 13.5167 16.3181 13.5167 15.3131V6.75998C13.5166 6.59796 13.4523 6.44258 13.3377 6.32802L13.3313 6.32166L8.04289 1.03323C7.92833 0.918661 7.77296 0.854279 7.61094 0.854248H2.31615ZM2.31615 2.07612H7V5.5381C7 6.54309 7.82782 7.37091 8.83282 7.37091H12.2948V15.3131C12.2948 15.6579 12.0286 15.924 11.6839 15.924H2.31615C1.97138 15.924 1.70521 15.6579 1.70521 15.3131V2.68706C1.70521 2.34229 1.97138 2.07612 2.31615 2.07612ZM8.22188 2.94003L11.4309 6.14904H8.83282C8.48804 6.14904 8.22188 5.88287 8.22188 5.5381V2.94003Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51483 11.5113L6.14545 13.1419L9.95604 9.3313",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBidAcceptedIcon);
export default __webpack_public_path__ + "static/media/bidAcceptedIcon.13d3adada645388052aa86d54358796f.svg";
export { ForwardRef as ReactComponent };